import { createContext, useContext, useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import { useLocation } from "react-router-dom";

const LenisCtx = createContext(null);
export const useLenis = () => useContext(LenisCtx);

export const scrollToId = (lenis, id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -70, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export function SmoothScroll({ children }) {
  const [lenis, setLenis] = useState(null);
  const rafRef = useRef(0);
  const { pathname, hash } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  useEffect(() => {
    if (isAdmin) return undefined;
    const l = new Lenis({ duration: 1.2, smoothWheel: true });
    const raf = (time) => { l.raf(time); rafRef.current = requestAnimationFrame(raf); };
    rafRef.current = requestAnimationFrame(raf);
    setLenis(l);
    return () => { cancelAnimationFrame(rafRef.current); l.destroy(); setLenis(null); };
  }, [isAdmin]);

  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => scrollToId(lenis, hash.slice(1)), 120);
      return () => clearTimeout(t);
    }
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash, lenis]);

  return <LenisCtx.Provider value={lenis}>{children}</LenisCtx.Provider>;
}
